export enum RoleType {
  // External role types
  ACCOUNT_OWNER,
  ADMIN,
  EMPLOYEE,
  HOST,
  DRIVER,

  // Internal role types
  HOSPITALITY,
  FINANCE,
  ENG,
}
